import { Box, Icon, Stack } from "@storyofams/react-ui";
import Image from "next/image";
import React from "react";

import { Star } from "~components/common/Icons";
import { Button, FixedRatio, Text } from "../../../components";
import {
  formatAlgoliaProductsForTracking,
  formatShopifyIdForTracking,
  storeProductClickOrigin,
  track,
} from "../../../lib";
import { AddToCartButton } from "./AddToCartButton";
import { AddToWishlistButton } from "./AddToWishlistButton";
import { DiscountLabel, Labels } from "./Labels";
export const BundleCard = React.memo(
  ({
    small,
    hideStockLabel,
    onClick,
    index,
    queryID,
    fromSearch,
    products,
    isSlider = false,
    isShowRating = true,
    ...product
  }: any) => {
    const review = product?.metafield?.value;
    const date1 = new Date(product?.published_at || product?.publishedAt);
    const date2 = new Date();
    const diffDays = Math.ceil(
      Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)
    );
    const isNew = diffDays < 90;
    const inStock =
      product?.variants_inventory_count > 0 || product?.availableForSale;
    const hasRating =
      !!review &&
      review !== "0.0" &&
      isShowRating &&
      !small &&
      product?.review_quantity?.value &&
      product?.review_quantity?.value !== "0";
    return (
      <Box position={"relative"}>
        <Button
          as="a"
          href={`/products/${product?.handle}`}
          width="100%"
          variant="unstyled"
          onClick={(e) => {
            if (onClick) {
              onClick(e);
            }
            storeProductClickOrigin(
              `${product.id}` || formatShopifyIdForTracking(product.id),
              window.location.pathname
            );
            track({
              event: "dl_select_item",
              ecommerce: {
                currencyCode: "EUR",
                click: {
                  actionField: { list: window.location.pathname },
                  products: product.objectID
                    ? formatAlgoliaProductsForTracking({
                        hits: [product],
                      })
                    : [
                        {
                          name: product.title,
                          id: product.variants?.edges?.[0]?.node?.sku || "",
                          product_id: formatShopifyIdForTracking(product.id),
                          variant_id:
                            formatShopifyIdForTracking(
                              product.variants?.edges?.[0]?.node?.id
                            ) || "",
                          price:
                            product?.priceRange?.minVariantPrice?.amount || "",
                          brand: product.vendor || "",
                          position: Number(index),
                          category: product.productType || "",
                          list: window.location.pathname,
                          variant:
                            formatShopifyIdForTracking(
                              product.variants?.edges?.[0]?.node?.id
                            ) || "",
                        },
                      ],
                },
              },
            });
          }}
        >
          <FixedRatio width="100%" ratio={[[282, 282]]} height={"100%"}>
            <Box
              width="100%"
              height="100%"
              position="relative"
              border="1px"
              borderRadius={"8px"}
              borderColor="#E2DFDF"
              bg="white"
            >
              <AddToWishlistButton
                product={product}
                border="none"
                bg="unset"
                position="absolute"
                left={-1}
                bottom={-1}
                zIndex={1}
              />

              <Labels
                left={1}
                top={hasRating ? "38px" : 1}
                position={"absolute"}
                hasRating={hasRating}
                isNew={isNew}
                inStock={inStock}
              />
              <DiscountLabel product={product} small={small} />
              <Box
                position="absolute"
                right={["-5px", -1]}
                bottom={"3px"}
                zIndex={1}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                {!small && (
                  <AddToCartButton isBundle border="none" product={product} />
                )}
              </Box>
              <Box position="relative" height="100%">
                {(product?.images?.edges?.[0]?.node?.url ||
                  product?.images?.edges?.[0]?.node?.originalSrc ||
                  product?.images?.edges?.[0]?.node?.image?.originalSrc) && (
                  <Image
                    layout="fill"
                    objectFit="contain"
                    objectPosition="center"
                    quality={70}
                    style={{ borderRadius: "8px" }}
                    loading="lazy"
                    src={
                      product?.metaImage?.value
                        ? product?.metaImage.value
                        : product?.images?.edges?.[0]?.node?.url ||
                          product?.images?.edges?.[0]?.node?.originalSrc ||
                          product?.images?.edges?.[0]?.node?.image?.originalSrc
                    }
                    alt={
                      product?.images?.edges?.[0]?.node?.altText ||
                      product?.title
                    }
                  />
                )}
              </Box>
            </Box>
          </FixedRatio>

          <Stack
            space={2}
            justifyContent={"space-between"}
            mt={"10px"}
            flex={1}
            width="100%"
            textAlign="left"
          >
            <Text
              fontSize={[isSlider ? "18px" : "14px", small ? 1.75 : "18px"]}
              lineHeight={[isSlider ? "25px" : "20px", small ? "16px" : "25px"]}
              fontWeight={600}
              style={{
                display: "-webkit-box",
                //@ts-ignore
                "-webkit-line-clamp": "2",
                "-webkit-box-orient": "vertical",
                overflow: "hidden",
              }}
            >
              {product?.title}
            </Text>
            <Box textAlign={"end"}>
              <Text
                color="#767473"
                fontWeight={500}
                lineHeight={[
                  isSlider ? "25px" : "20px",
                  small ? "16px" : "25px",
                ]}
                fontSize={[isSlider ? "16px" : "12px", small ? 1.75 : "16px"]}
              >
                {product?.variants?.nodes[0] &&
                  "€" + product.variants.nodes[0].price}
              </Text>
            </Box>
          </Stack>
        </Button>
        {hasRating && (
          <Box
            display="flex"
            position={"absolute"}
            height={"24px"}
            top={1}
            left={1}
            border="1px solid #E2DFDF"
            backgroundColor={"#FCF9F7"}
            borderRadius={"6px"}
            px="6px"
            justifyContent="space-between"
            alignItems={"center"}
          >
            <Icon
              fontSize={"15px"}
              color="oldPink"
              icon={Star}
              pb={"1px"}
              mr={"6px"}
            />
            <Text
              fontWeight={500}
              lineHeight="12px"
              fontSize={"12px"}
              mr={["5px", small ? "5px" : "7px"]}
            >
              {review || product.metafield.value}
            </Text>
            <Text
              display={["none", "block"]}
              lineHeight="12px"
              fontSize={"12px"}
            >{`(${product?.review_quantity?.value} ${
              small ? "" : "reviews"
            })`}</Text>
            <Text
              display={["block", "none"]}
              lineHeight="12px"
              fontSize={"12px"}
            >{`(${product?.review_quantity?.value})`}</Text>
          </Box>
        )}
      </Box>
    );
  }
);
